export default "__VITE_ASSET__CNcoHJUq__"